import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import type { Subscription } from 'rxjs';

import { Constants } from '@shared/models';
import type { TMessage } from '@shared/models';
import { ViewBasePage } from '@shared/pages';
import { CapacitorService, MessageCenterService } from '@shared/services';

@Component({
    'selector': 'app-help',
    'templateUrl': './help.page.html',
    'styleUrls': ['./help.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class HelpPage extends ViewBasePage implements OnInit, OnDestroy {
    public disabled: boolean;
    public unreadMessagesCount = 0;
    private messagesSubscription: Subscription | null = null;

    constructor(
        private capacitorService: CapacitorService,
        private messageCenterService: MessageCenterService,
        injector: Injector
    ) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(Constants.VIEW_HELP);
    }

    public override ngOnInit(): void {
        super.ngOnInit();
        // Subscribe to messages for unread count
        this.messagesSubscription = this.messageCenterService.getFilteredObservable()
            .subscribe((messages: TMessage[]) => {
                this.unreadMessagesCount = messages.filter(
                    // m => m.status === 'unread' && m.status !== 'dismissed'
                    m => m.status === 'unread'
                ).length;
            });
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
        if (this.messagesSubscription) {
            this.messagesSubscription.unsubscribe();
        }
    }

    // public initMoreMenu(): void {
    //     this.resetPopoverMenu();
    //     this.pushPopoverMenuItem('Show Tour', 'show-help-tour');
    // }

    public onContactUsClick() {
        this.router.navigateByUrl('/help/contactUs');
    }

    public onMessageCenterClick(): void {
        this.router.navigateByUrl('/help/messageCenter');
    }

    public onTutorialsClick() {
        this.router.navigateByUrl('/help/tutorials');
    }

    public async onOpenWebsite() {
        // const url = 'https://www.shuttlenomix.com';
        await this.capacitorService.openUrl(Constants.COMPANY_YOUTUBE_CHANNEL_URL);
    }

    public onIntroductionClick(): void {
        this.router.navigateByUrl('/help/introduction');
    }

    public onFeedbackClick(): void {
        this.router.navigateByUrl('/help/feedback');
    }

    // // Go to the Usetiful console and load the:
    // // Vocabulary Tour -> url = https://www.usetiful.com/product-tours/creator/20329
    // // Sidemenu Tour   -> url = https://www.usetiful.com/product-tours/creator/20294
    // // Workflow Tour   -> url = https://www.usetiful.com/product-tours/creator/20332
    // // The tourId are the digits after the creator/
    // public showTour(tourId: number): void {
    //     (<any>window).USETIFUL.tour.start(tourId);
    // }
}
